<template>
    <button
        no-interact
        v-bind="extendedAttrs"
        v-bind:class="classObj"
        class="btn shadow-none">
        <slot />
    </button>
</template>
<script setup>
    import { computed, useAttrs } from "vue";
    import { useAwsRumClick } from "../Util/AwsRumUtil.js"; // Import the composable
    defineOptions({ inheritAttrs: false });

    const attrs = useAttrs();

    const extendedAttrs = computed(() => (attrs.onClick ? { ...attrs, onClick: useAwsRumClick(attrs) } : attrs));

    const props = defineProps({
        primary: { type: Boolean, required: false, default: false },
        link: { type: Boolean, required: false, default: false },
        warning: { type: Boolean, required: false, default: false },
        success: { type: Boolean, required: false, default: false },
        small: { type: Boolean, required: false, default: false },
        outline: { type: Boolean, required: false, default: false }
    });

    const classObj = computed(() => ({
        "btn-primary": props.primary,
        "btn-link": props.link,
        "btn-warning": props.warning,
        "btn-success": props.success,
        "btn-secondary": !props.primary && !props.link && !props.warning && !props.success && !props.outline,
        "btn-sm": props.small,
        "pc-btn-min-width-8spacer": !props.link
    }));
</script>
